import SeoCard from 'strapi/component/seo/SeoCard';
import { OpenGraphTypes, SeoStrapiComponent } from 'strapi/component/seo/types';
import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

export const collectSeoComponentParams = (data?: SeoStrapiComponent) => {
  const generalCard = {
    title: data?.generalCard?.title,
    description: data?.generalCard?.description,
    canonical: data?.generalCard?.canonical,
  };

  const openGraphType = OpenGraphTypes.find(
    (type) => type === data?.openGraphCard?.type
  );

  const openGraphCard = {
    title: data?.openGraphCard?.title,
    description: data?.openGraphCard?.description,
    type: openGraphType,
    imageUrl: data?.openGraphCard?.image?.url,
    imageAlt: data?.openGraphCard?.image?.alternativeText ?? undefined,
  };

  return {
    generalCard:
      generalCard?.title || generalCard?.description || generalCard?.canonical
        ? generalCard
        : undefined,
    openGraphCard:
      openGraphCard?.title ||
      openGraphCard?.description ||
      openGraphCard?.type ||
      openGraphCard?.imageUrl
        ? openGraphCard
        : undefined,
  };
};

export const collectSeoParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof SeoCard> | undefined => {
  if (!('seo' in page) || !page.seo) {
    return undefined;
  }

  return {
    component: ReactComponentType.SeoCard,
    props: {
      ...collectSeoComponentParams(page.seo),
    },
  };
};
